import ApiErrorCode from '../ApiErrorCode';
import CommonAdapter from '../../adapters/CommonAdapter';
import loadExtensionCustomProperties from '../../services/loadExtensionCustomProperties';
import { ApiMethodCallback } from '../ApiMethod';
import { createCustomPropertiesResult } from './CustomPropertiesResult';
import { createErrorResult } from '../ApiMethodResponseCreator';
import { getAdapter } from '../../adapters/AdapterManager';
import { getExtensionId } from 'owa-addins-store';

export default async function loadCustomPropertiesApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: null,
    callback: ApiMethodCallback
) {
    const adapter: CommonAdapter = getAdapter(hostItemIndex) as CommonAdapter;
    const itemId = adapter.getItemId();
    if (!itemId) {
        callback(createCustomPropertiesResult('', true, '{}'));
        return;
    }
    const extensionId = getExtensionId(controlId);
    let itemOwner;

    try {
        if (adapter.isSharedItem && adapter.getSharedProperties && adapter.isSharedItem()) {
            const sharedProperties = adapter.getSharedProperties();
            itemOwner = sharedProperties.owner;
        }

        const result = await loadExtensionCustomProperties(extensionId, itemId, itemOwner);
        callback(
            createCustomPropertiesResult(
                result.ErrorMessage,
                result.WasSuccessful,
                result.CustomProperties
            )
        );
    } catch (e) {
        callback(createErrorResult(ApiErrorCode.GenericResponseError));
    }
}
